export const accessControl = (subject, verb, role) => {
  return authorization[subject][verb][role];
}

// Role
export const ROLE_OWNER = 'owner';
export const ROLE_ADMIN = 'admin';
export const ROLE_GENERAL = 'general';
export const ROLE_WNI = 'WNI';

// Verb
export const VERB_CREATE = 'VERB_CREATE';
export const VERB_UPDATE = 'VERB_UPDATE';
export const VERB_DELETE = 'VERB_DELETE';
export const VERB_READ = 'VERB_READ';

// Subject
export const SUBJ_COPI_SETTING_LIST = 'SUBJ_COPI_SETTING_LIST';
export const SUBJ_COPI_AIRCRAFT_LINKAGE = 'SUBJ_COPI_AIRCRAFT_LINKAGE';
export const SUBJ_COPI_DISPLAY_SETTINGS = 'SUBJ_COPI_DISPLAY_SETTINGS';
export const SUBJ_AIRCRAFT_SETTING_LIST = 'SUBJ_AIRCRAFT_SETTING_LIST';
export const SUBJ_AIRCRAFT_GROUP_SETTING_LIST = 'SUBJ_AIRCRAFT_GROUP_SETTING_LIST';
export const SUBJ_AIRCRAFT_GROUP_LINKAGE_AIRCRAFT = 'SUBJ_AIRCRAFT_GROUP_LINKAGE_AIRCRAFT';
export const SUBJ_AIRCRAFT_GROUP_EXTERNAL_LINKAGE_AIRCRAFT = 'SUBJ_AIRCRAFT_GROUP_EXTERNAL_LINKAGE_AIRCRAFT';
export const SUBJ_AIRCRAFT_GROUP_LINKAGE_USER_GROUP = 'SUBJ_AIRCRAFT_GROUP_LINKAGE_USER_GROUP';
export const SUBJ_POINT_AREA_SETTING_LIST = 'SUBJ_POINT_AREA_SETTING_LIST';
export const SUBJ_POINT_AREA_SETTING_ICON = 'SUBJ_POINT_AREA_SETTING_ICON';
export const SUBJ_POINT_AREA_SETTING_FILE = 'SUBJ_POINT_AREA_SETTING_FILE';
export const SUBJ_AIRPORT_GROUP_SETTING = 'SUBJ_AIRPORT_GROUP_SETTING';
export const SUBJ_THRESHOLD_SETTING_LIST = 'SUBJ_THRESHOLD_SETTING_LIST';
export const SUBJ_CHART_SETTING_LIST = 'SUBJ_CHART_SETTING_LIST';
export const SUBJ_WORKSPACE_SETTING = 'SUBJ_WORKSPACE_SETTING';

const authorization = {
  [SUBJ_COPI_SETTING_LIST]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_COPI_AIRCRAFT_LINKAGE]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_COPI_DISPLAY_SETTINGS]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_AIRCRAFT_SETTING_LIST]: {
    [VERB_CREATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_DELETE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_AIRCRAFT_GROUP_SETTING_LIST]: {
    [VERB_CREATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_DELETE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_AIRCRAFT_GROUP_LINKAGE_AIRCRAFT]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
  },
  [SUBJ_AIRCRAFT_GROUP_EXTERNAL_LINKAGE_AIRCRAFT]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
  },
  [SUBJ_AIRCRAFT_GROUP_LINKAGE_USER_GROUP]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
  },
  [SUBJ_POINT_AREA_SETTING_LIST]: {
    [VERB_CREATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_DELETE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_POINT_AREA_SETTING_ICON]: {
    [VERB_CREATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_DELETE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_POINT_AREA_SETTING_FILE]: {
    [VERB_CREATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_DELETE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_AIRPORT_GROUP_SETTING]: {
    [VERB_CREATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
    [VERB_DELETE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    }
  },
  [SUBJ_THRESHOLD_SETTING_LIST]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
  },
  [SUBJ_CHART_SETTING_LIST]: {
    [VERB_UPDATE]: {
      [ROLE_WNI]: true,
      [ROLE_ADMIN]: true
    },
  },
  [SUBJ_WORKSPACE_SETTING]: {
    [VERB_READ]: {
      [ROLE_WNI]: false,
      [ROLE_ADMIN]: true,
      [ROLE_GENERAL]: true,
    },
  }
}